import * as React from 'react';
import { IconButton, List, ListItem, ListItemText, Popover, Tooltip, Typography } from "@mui/material";
import { ThemeProvider, styled } from '@mui/material/styles';
import CamelCartaoCode from './CamelCartaoCode';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function CamelMongoDBModel(props) {
    const {action, setCode} = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const doAction=()=>{
      if(action)action('camel-js-mongoDb-findByID.js');
      handleClose();
    }
    return (
        <React.Fragment>
            <Tooltip title="Operações MongoDB">
                <IB
                    color={'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <img src="/svg/mongoDB.svg"/>
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true}>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={()=>doAction('camel-js-mongoDb-findByID.js')}>
                        <ListItemText 
                            primary="Query por ID" 
                            secondary={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                  >
                                    QueryParameter
                                  </Typography>
                                  {" — 'http://xxx?id={id}'"}
                                </React.Fragment>
                              } 
                        />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => {
                        action('camel-js-queryExemplo.js');
                        handleClose();
                    }}>
                        <ListItemText 
                            primary="Query "
                            secondary={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                  >
                                    Busca
                                  </Typography>
                                  {" — filtro simples"}
                                </React.Fragment>
                              } 
                        />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => {
                        action('camel-js-insertUpdate.js');
                        handleClose();
                    }}>
                        <ListItemText 
                            primary="Insert/Update"
                            secondary={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                  >
                                    Exemplo
                                  </Typography>
                                  {" — inclusão de registro"}
                                </React.Fragment>
                              } 
                        />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => {
                        action('camel-js-bulkWrite.js');
                        handleClose();
                    }}>
                        <ListItemText 
                            primary="Operação Bulk Write"
                            secondary={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                  >
                                    Collection
                                  </Typography>
                                  {" — Gera um alista de operações"}
                                </React.Fragment>
                              } 
                        />
                    </ListItem>
                    <CamelCartaoCode action={handleClose} setCode={setCode}/>
                </List>
            </Popover>
        </React.Fragment>
    )
}